import { render, staticRenderFns } from "./Tweet.vue?vue&type=template&id=0cada386&scoped=true&"
import script from "./Tweet.vue?vue&type=script&lang=js&"
export * from "./Tweet.vue?vue&type=script&lang=js&"
import style0 from "./Tweet.vue?vue&type=style&index=0&id=0cada386&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cada386",
  null
  
)

export default component.exports